<template>
  <div v-loading="$mip('getBills')" class="widget">
    <div class="widget__body">
      <non-data-stub :stub-data="bills">
        <div v-for="(bill, index) in bills" :key="bill.id" class="row">
          <div class="col col-8">
            <h3 class="mb-12">Счет № {{ bill.number }}</h3>
            <div>
              <div>Дата счета: {{ formatDate(bill.date) }}</div>
              <div>Предмет платежа: {{ bill.invoiceSubject }}</div>
              <div>К оплате: {{ formatNumber(bill.cost, 'currency') }}</div>
            </div>
          </div>
          <div class="col col-4 flex-x-end">
            <a
              class="link-muted icon-text-align nowrap mb-12"
              @click="downloadInvoice(bill)">
              <span class="icon icon-current mr-8" v-html="require('@/assets/img/icons/download.svg')" />
              Скачать счет
            </a>
            <a class="link-muted icon-text-align nowrap" href="#" @click="deleteBill(bill.id)">
              <span class="icon icon-current mr-8" v-html="require('@/assets/img/icons/delete.svg')" />
              Удалить счет
            </a>
          </div>
          <div v-if="index !== bills.length - 1" class="divider my-24" />
        </div>
      </non-data-stub>
    </div>
  </div>
</template>

<script>
  import { formatDate, formatNumber } from '@/utils'
  import NonDataStub from '@/components/stub/NonDataStub.vue'

  export default {
    components: {
      NonDataStub
    },

    data() {
      return {
        bills: []
      }
    },

    async created() {
      this.getInvoices()
    },

    methods: {
      formatDate,
      formatNumber,
      downloadInvoice({ number, documentId: billId }) {
        this.$http.getFile('getBillPrintForm', { fileName: `Счет № ${number}`, params: { billId } })
      },

      async getInvoices() {
        this.bills = (await this.$http.getBills()).data
      },

      async deleteBill(id) {
        this.$confirm('Вы уверены, что хотите удалить счет?', 'Удаление счета', {
          confirmButtonText: 'Удалить',
          cancelButtonText: 'Отмена',
          confirmButtonClass: 'bg-danger',
          type: 'warning'
        }).then(async () => {
          await this.$http.deleteBill(id)
          this.bills = this.bills.filter(bill => bill.id !== id)
          this.$notify({
            title: 'Удаление счета',
            message: 'Счет удален',
            type: 'success'
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.divider {
  padding: relative;
  top: -1px;
}
</style>